import { useI18n, type Locale } from "@/lib/i18n";

export function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const { locale, setLocale } = useI18n();
  const opts: Locale[] = ["fr", "en"];
  return (
    <div
      role="group"
      aria-label="Language"
      className={`inline-flex items-center rounded-md border border-border bg-card text-xs font-medium ${compact ? "" : "shadow-card"}`}
    >
      {opts.map((l, i) => (
        <button
          key={l}
          onClick={() => setLocale(l)}
          className={`px-2.5 py-1 uppercase tracking-wider transition-colors ${
            locale === l
              ? "bg-foreground text-background"
              : "text-muted-foreground hover:text-foreground"
          } ${i === 0 ? "rounded-l-md" : "rounded-r-md"}`}
          aria-pressed={locale === l}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
